<template>
  <v-app class="us-v-app">
    <v-app-bar color="blue-grey" dense dark app>
      <v-btn icon @click="goBack">
        <v-icon style="font-size:2rem;">mdi-chevron-left</v-icon>
      </v-btn>
      <v-toolbar-title style="font-size:1rem;">修改版本</v-toolbar-title>
      <v-spacer></v-spacer>
      <v-btn color="success" @click="goSave">保存</v-btn>
    </v-app-bar>
    <v-content>
      <v-container>
        <v-list-item>
          <v-list-item-icon style="width: 60px;margin-right:0px;">
            <span style="color:#808080;font-size:16px">版本号:</span>
          </v-list-item-icon>
          <v-list-item-content>
            <div>
              <select id="us-select" style="color:#808080;width:100%;outline:none;font-size:16px" v-model="select">
                <option :value="item.value" v-for="(item,index) in items" :key="index">{{item.label}}</option>
              </select>
              <i class="fa fa-angle-down" aria-hidden="true" style="font-size:1.6rem;color:#808080;position:absolute;right:0.2rem;pointer-events:none;top:1rem;" ></i>
            </div>
          </v-list-item-content>
        </v-list-item>
      </v-container>
    </v-content>
  </v-app>
</template>

<script>
export default {
  components: {},
  props: {
  },
  data() {
    return {
      items: [{ label: '稳定版', value: 'v1' },
        { label: '开发版公测', value: 'v2' },
        { label: '开发版', value: 'v3' }],
      select: this.getVer(),
      userInfo: {}
    }
  },
  computed: {},
  mounted() {},
  created() {},
  methods: {
    goBack() {
      this.$router.goBack()
    },
    async goSave() {
      var that = this
      if (!that.select) {
        return
      }
      var ver = that.select
      // console.log(ver)
      that.$api.bz.changeVersion({ gzh_ver: ver }).then(res => {
        if (!res.success) {
          that.$toast.warning('保存失败')
          return
        }
        that.$toast.success('保存成功')
        setTimeout(function() {
          const development = process.env.NODE_ENV === 'development';
          if (development) {
            that.$AppHelper.pullUserCustomData();
            that.$AppHelper.pullNewUserToken();
            // that.goBack()
            // that.$router.replace('/Home')
            that.$router.push('/Home')
            return
          }
          window.location.href = '//wechat-auth.gz7x24.cn?r=' + that.random(0, 10)
        }, 1500);
      })
    },
    getVer() {
      var that = this
      var vers = 'v1'
      that.userInfo = that.$AppHelper.getUserInfo()
      if (that.userInfo) {
        vers = that.userInfo.gzh_ver
        if (!(vers === 'v1' || vers === 'v2' || vers === 'v3')) {
          vers = 'v1'
        }
      }
      return vers
    },
    random(min, max) {
      return Math.random() * (max - min) + min;
    }
  }
}
</script>

<style scoped>
.us-toggle-company{
  font-size:0.88rem;
  padding-bottom:0.6rem;
  padding-left:1.2rem;
  position: relative;
}
</style>
